import { render } from "./EditClientAffecterPage.vue?vue&type=template&id=2507d1da&ts=true"
import script from "./EditClientAffecterPage.vue?vue&type=script&lang=ts"
export * from "./EditClientAffecterPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__